import type { Comment } from '@/@types/comment'
import { Attachment, AttachmentType } from '@/states/attachment'
import { z } from 'zod'

export interface ReplyToComment {
	to: Comment
	// 如果 threadId 存在，则表示要回复的不是一级评论
	// 一级评论是没有 threadId 的
	threadId?: string
}

export const CommentFormSchema = z.object({
	// 帖子内容验证
	content: z.string(),

	// 附件验证
	attachments: z.array(z.custom<Attachment>()).superRefine((attachments, ctx) => {
		const hasPictures = attachments.some((item) => item.type === AttachmentType.PICTURE)
		const hasVideo = attachments.some((item) => item.type === AttachmentType.VIDEO)
		const hasLink = attachments.some((item) => item.type === AttachmentType.LINK)

		if (hasVideo || hasLink) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: '不支持添加视频或链接',
			})
		}

		if (hasPictures && attachments.length > 1) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: '只能添加1张图片',
			})
		}
	}),

	isSyncToPersonalUpdate: z.boolean(),
})

export type CommentFormValue = z.infer<typeof CommentFormSchema>
